"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.MaybeSkeletonText = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Skeleton = require("../Skeleton");
var _classnames = _interopRequireDefault(require("classnames"));
var _SkeletonTextModule = _interopRequireDefault(require("./SkeletonText.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Props shared between SkeletonText and MaybeSkeletonText
 */

/**
 * Props specific to SkeletonText
 */

var SkeletonText = _ref => {
  var as = _ref.as,
    classNameProp = _ref.className,
    _ref$asyncText = _ref.asyncText,
    text = _ref$asyncText.text,
    isLoading = _ref$asyncText.isLoading,
    errorTextProp = _ref$asyncText.errorText,
    errorClassName = _ref$asyncText.errorClassName,
    skeletonOptions = _ref.skeletonOptions;
  var isError = !isLoading && text === undefined;
  var className = (0, _classnames.default)(_SkeletonTextModule.default.Container, classNameProp, isError && errorClassName);
  var children;
  if (isLoading) {
    children = /*#__PURE__*/_react.default.createElement(_Skeleton.Skeleton, skeletonOptions);
  } else if (text !== undefined) {
    children = text;
  } else {
    children = errorTextProp !== null && errorTextProp !== void 0 ? errorTextProp : 'ERR';
  }
  return /*#__PURE__*/(0, _react.createElement)(as !== null && as !== void 0 ? as : 'span', {
    className
  }, children);
};

/**
 * MaybeSkeletonText
 * Simple utility wrapper for when you don't know if you have an AsyncText or a string
 */

/**
 * Props specific to MaybeSkeletonText
 */
exports.SkeletonText = SkeletonText;
var MaybeSkeletonText = props => {
  var asyncText = typeof props.text === 'object' ? props.text : {
    text: props.text,
    isLoading: false
  };
  return /*#__PURE__*/_react.default.createElement(SkeletonText, _extends({}, props, {
    asyncText: asyncText
  }));
};
exports.MaybeSkeletonText = MaybeSkeletonText;
//# sourceMappingURL=SkeletonText.js.map